{
  "blocked": "Fix the marked changes to save them.",
  "discard": "Discard",
  "edit": "Edit {{text}}",
  "keep": "Done",
  "saving": "Saving…",
  "undo": "Undo the change to {{text}}",
  "unsaved_one": "{{count}} unsaved change",
  "unsaved_other": "{{count}} unsaved changes"
}
